'use client';

import React, { forwardRef, type HTMLAttributes } from 'react';
import {
  Button2 as Button,
  IconButton2 as IconButton,
} from 'components/Button2';
import type { ButtonProps } from 'components/Button2/Button2';
import type { IconButtonProps } from 'components/Button2/IconButton';
import { IconX } from '@frameio/vapor-icons';
import styles from './Toast.module.css';

type ButtonGroupProps = HTMLAttributes<HTMLDivElement>;

const ToastButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} variant="secondary" {...props} />
));
// allow easier debugging for consumers
ToastButton.displayName = 'ToastButton';

const ToastButtonGroup = (props: ButtonGroupProps) => (
  <div className={styles.toastButtonGroup} {...props} />
);

type ToastCloseButtonProps = Omit<IconButtonProps, 'icon' | 'variant'>;
/**
 * @description A close button for Toast components
 */
function ToastCloseButton({ label, onPress }: ToastCloseButtonProps) {
  return (
    <div className={styles.toastButtonCloseContainer}>
      <IconButton
        data-testid="toast-alert--close-button"
        icon={<IconX />}
        label={label}
        onPress={onPress}
        variant="tertiary"
      />
    </div>
  );
}
export type { ButtonGroupProps, ToastCloseButtonProps };
export { ToastButton, ToastButtonGroup, ToastCloseButton };
